export const SOFTLINE_PERMISSION_MDC_INVENTORY = 'SOFTAPPS.MDC.INVENTORY';
